<template>
  <div class="route-tabs">
    <q-tabs
      align="left"
      shrink
      class="shadow3 border-radius-sm bg-white-1"
      content-class="tabs-wrapper"
      indicator-color="primary-1"
    >
      <q-route-tab
        v-for="tab of tabs"
        :key="tab.name"
        :to="tab.route"
        :ripple="false"
        class="no-padding"
        content-class="text-body-1 text-secondary-1 no-padding"
      >
        <slot :tab="tab">
          {{ tab.name }}
        </slot>
      </q-route-tab>
    </q-tabs>
  </div>
</template>

<script>
export default {
  props: {
    tabs: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/fonts';

.route-tabs {
  ::v-deep .tabs-wrapper {
    display: grid;
    grid-auto-flow: column;
    gap: var(--r-space-md);
    padding: 0 48px;
    justify-content: start;

    .q-tab {
      padding: var(--r-space-lg) var(--r-space-sm) var(--r-space-md) !important;

      &--active .q-tab__content {
        @extend .text-subtitle-3;
      }

      &__indicator {
        height: 3px;
        border-radius: 3px;
      }
    }

    .q-hoverable {
      .q-focus-helper,
      .q-focus-helper::before,
      .q-focus-helper::after {
        opacity: 1 !important;
      }

      &:hover,
      &:focus {
        .q-focus-helper::before,
        .q-focus-helper::after {
          background: var(--r-white-2) !important;
        }
      }
    }
  }
}
</style>

<docs>
### Route Tabs

This is a styled component for using tabs.
It expects an array of objects, and each object must have this structure:

```json
{
  name: String,
  route: String | Object
}
```

### Simple example

*Note: The navigation in the example below doesn't works because there are some issues combining QRouteTab and VueRouter with vue-styleguidist*

*In your app code however, everything will be working just fine*

```jsx
<template>
  <div class="page">
    <RouteTabs :tabs="tabs" />
  </div>
</template>

<script>
  import RouteTabs from "@/ui/RouteTabs";

  export default {
    components: {
      RouteTabs
    },

    data: function () {
      return {
        tabs: [
          { name: 'First', route:'/' },
          { name: 'Second', route: '/about' }
        ]
      }
    }
  }
</script>
```
</docs>
